module.exports = __webpack_public_path__ + "static/media/bh-logo-sm.c7c79abf.svg";